import { Link } from 'react-router-dom';

const categoryLinks = [
  { label: 'Skincare', path: '/skincare' },
  { label: 'Makeup', path: '/makeup' },
  { label: 'Wellness', path: '/wellness' },
];

const resourceLinks = [
  { label: 'About', path: '/about' },
  { label: 'Affiliate Disclosure', path: '/affiliate-disclosure' },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#3A4D39] text-[#FDFCF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Link to="/" className="font-heading text-2xl md:text-3xl font-semibold">
              SimplyCuratedGuide
            </Link>
            <p className="mt-4 text-sm leading-relaxed opacity-80 max-w-md">
              Honest, calm, and practical product recommendations for your skincare, makeup, and wellness journey. We believe in transparency and simplicity.
            </p>
          </div>

          {/* Categories Column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-medium mb-4 opacity-60">Categories</h4>
            <ul className="space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-medium mb-4 opacity-60">Resources</h4>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-sm opacity-80 hover:opacity-100 transition-opacity duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Affiliate Disclosure Notice */}
        <div className="mt-12 pt-8 border-t border-white/20">
          <p data-testid="footer-affiliate-notice" className="text-xs leading-relaxed opacity-60 max-w-3xl">
            <span className="font-semibold">Affiliate Disclosure:</span> Some links on this site are affiliate links. If you purchase through them, we may earn a commission at no extra cost to you. We only recommend products we genuinely believe may be helpful.
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-white/10">
          <p className="text-xs opacity-50">
            &copy; {new Date().getFullYear()} SimplyCuratedGuide. All rights reserved. This site is for informational purposes only and does not provide medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
